// extracted by mini-css-extract-plugin
export var footer = "_q7-5";
export var fulfillmentInput = "_q7-0";
export var shipDateInput = "_q7-1";
export var shipmentModal = "_q7-2";
export var shipmentModalContent = "_q7-3";
export var tableContainer = "_q7-4";